module.exports = __webpack_public_path__ + "static/pay-by-po-payment-method-4dca6d6efd0a9bbfce9de6fa2d813122.png";